import { DestructiveActionDialog } from './DestructiveActionDialog';

interface MirroredSourceDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  partnerName?: string;
}

export function MirroredSourceDeleteDialog({
  open,
  onClose,
  onConfirm,
  partnerName,
}: MirroredSourceDeleteDialogProps) {
  const partnerClientName = partnerName || 'their partner';

  return (
    <DestructiveActionDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Delete Shared Funding Source"
      description={
        <p>
          This funding source is shared with {partnerClientName}. Deleting it removes it from{' '}
          {partnerClientName}&apos;s plan too.
        </p>
      }
      confirmButtonText="Delete"
      cancelButtonText="Cancel"
    />
  );
}
